<template>
    <b-modal id="no-negative-emotion-pop-up" centered scrollable hide-footer hide-header modal-class="modal-full-height">
            <div class="col-12 step-content">
               <b-row class="row-navbar-padding" />
                <b-col cols="12" class="text-center mt-4 mb-5 simple-text" tabindex="0">
                    Perhaps this is not a good problem to try and solve. You can cancel this project and start a new one or you can continue on without a response .
                </b-col>
            </div>
            <b-col cols="12" class="pt-5">
                <b-row :class="{'isCareerEntrep': isJACareerEntrepreApp}" class="button-row-cover">
                    <b-col cols="12" class="pr-0 button-start">
                        <b-button block variant="primary" size="lg" @click="$router.push({ name: 'be_start_project' })" aria-label="Start New Project " type="submit" >
                            Start New Project
                        </b-button>
                    </b-col>
                    <b-col cols="12"  class="text-center">
                        <b-button block variant="light" size="lg" aria-label="Ignore and Continue"  @click="$bvModal.hide('no-negative-emotion-pop-up')">
                            Ignore and Continue
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>
    </b-modal>
</template>

<script>

    export default {
        name: "NoNegativeEmotionPopUp",
    }
</script>
<style lang="stylus" scoped>

    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .step-content
        min-height calc(90vh - 160px)
        overflow-wrap: anywhere;

    .row-navbar-padding
        padding-top 107px

    .button-row
        padding-top 50px
        padding-bottom 28px

    .button-row-cover
        margin-top -20px
        padding-bottom 28px

    .modal-dialog-scrollable
        .modal-header
               .close
                  display none !important
    .button-row
        padding-top 50px
        padding-bottom 28px

    .isCareerEntrep
        .btn-primary
            background-color color-green-light
            &:hover
                background-color color-green-dark
        .btn-light
            color color-green-light
            background none !important
            &:not(:disabled):not(.disabled).active, &:not(:disabled):not(.disabled):active,
            &:hover
                color color-green-dark
                box-shadow none !important


    +for_breakpoint(xs)
       .font-size
            .row-navbar-padding
                padding-top 125px !important

    +for_breakpoint(md)
        .row-navbar-padding
            padding-top 40px
        .button-start
           padding-right: 15px !important

    +for_breakpoint(md)
        .button-start
           padding-right: 15px !important

</style>

